import { Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from 'pixi.js';
import tuktukDemoState, { globalData } from './globalData';
import { gameStates } from './gameStates';
import { arrowVisibility, autoGraphic, gameAssets, instances, showErrorPopup, turboGraphic } from './gameUI';
import { processSpinResult } from './processSpinResult';
import { playContinue, playJeepneyLeft, playJeepneyRight, playPlay } from './soundManager';
import { tweenFadeAppear } from './utility';
import { isOnline } from './gameService';
import gsap from 'gsap';


export class spinButton {
    spinButtonContainer = null;
    spinButtonSprite = null;
    hitGraphics = null

    hitArea = 185

    buttonSpineAnimation = [];

    roundText = null;

    constructor(x = 0, y = 0) {
        this.spinButtonContainer = new PIXI.Container();
        this.spinButtonContainer.position.set(x, y);

        this.spinButtonSprite = new PIXI.Sprite(PIXI.Assets.get('play_btn_normal'));
        this.spinButtonSprite.anchor.set(0.5);
        this.spinButtonSprite.scale.set(0.95);
        this.spinButtonSprite.interactive = true;
        this.spinButtonContainer.addChild(this.spinButtonSprite);

        gameAssets.timer = new PIXI.Sprite(PIXI.Assets.get('timer_100'));
        gameAssets.timer.anchor.set(0.5);
        gameAssets.timer.scale.set(1.25)
        gameAssets.timer.visible = true;

        this.timerMask = new PIXI.Graphics();
        this.timerMask.x = gameAssets.timer.x;
        this.timerMask.y = gameAssets.timer.y;
        gameAssets.timer.mask = this.timerMask;

        this.spinButtonContainer.scale.set(1);
        this.setupSpinButtonSpines();
        this.drawHitGraphics();
        this.setupRoundText();
    }

    startCircularTimer(sprite, duration = 10) {
        const mask = sprite.mask;

        mask.clear();
        mask.beginFill(0xffffff);
        mask.drawCircle(0, 0, sprite.width / 2);
        mask.endFill();
        sprite.texture = PIXI.Assets.get('timer_100');

        const progressObj = { progress: 0 };
        let halfwayReached = false;
        let lowReached = false;

        const tween = gsap.to(progressObj, {
            progress: 1,
            duration: duration,
            ease: "none",
            onUpdate: () => {
                const radius = sprite.width / 2;
                const startAngle = -Math.PI / 2;
                const endAngle = startAngle - (Math.PI * 2 * (1 - progressObj.progress));

                mask.clear();
                mask.beginFill(0xffffff);
                mask.moveTo(0, 0);
                mask.arc(0, 0, radius, startAngle, endAngle, true);
                mask.lineTo(0, 0);
                mask.endFill();

                if (!halfwayReached && progressObj.progress >= 0.5) {
                    halfwayReached = true;
                    sprite.texture = PIXI.Assets.get('timer_50');
                }

                if (!lowReached && progressObj.progress >= 0.75) {
                    lowReached = true;
                    sprite.texture = PIXI.Assets.get('timer_25');
                }
            },
            onComplete: () => {
                autoGraphic.interactive = false;
                turboGraphic.interactive = false;
                gameAssets.arrowRightEnabled.interactive = false;
                gameAssets.arrowLeftEnabled.interactive = false;
                globalData.timer = true;
                console.log("Timer finished");
                // random();

                gameAssets.menubarButton.tint = 0x606060
                gameAssets.menubarButton.interactive = false
                globalData.currentRound += 1;
                setTimeout(() => {
                    const jeepneyLane = instances.Obstacles.generateRandomNumber(0, 1);
                    if (globalData.currentGameState == gameStates.ROUND_START) {
                        // gameAssets.arrowLeftEnabled.interactive = false;
                        // gameAssets.arrowRightEnabled.interactive = false;
                        if (jeepneyLane) {
                            globalData.jeepneyLane = "R";
                            gameAssets.arrowRightHover.visible = true;
                            // playJeepneyRight()
                        } else {
                            globalData.jeepneyLane = "L";
                            gameAssets.arrowLeftHover.visible = true;
                            // playJeepneyLeft()
                        }
                        // instances.SpinButton.updateRoundText();
                        setTimeout(() => {
                            arrowVisibility(false);
                            if (globalData.jeepneyLane === "R") {

                                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_front_to_R_side', false)
                                setTimeout(() => {

                                    gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true)

                                    playJeepneyRight();
                                    processSpinResult();
                                }, 400);
                            } else if (globalData.jeepneyLane === "L") {
                                gameAssets.jeepney.state.setAnimation(0, 'tuktuk_front_to_L_side', false)
                                setTimeout(() => {
                                    gameAssets.jeepney.state.setAnimation(0, "tuktuk_L_side", true);

                                    playJeepneyLeft();
                                    processSpinResult();
                                }, 400);
                            }
                            gameAssets.arrowRightHover.visible = false;
                            gameAssets.arrowLeftHover.visible = false;
                            autoGraphic.interactive = true;
                            turboGraphic.interactive = true;
                            gameAssets.arrowLeftEnabled.interactive = true;
                            gameAssets.arrowRightEnabled.interactive = true;
                        }, 500);
                    }
                }, 300);

                sprite.texture = PIXI.Assets.get('timer_100');
                mask.clear();
                mask.beginFill(0xffffff);
                mask.drawCircle(0, 0, sprite.width / 2);
                mask.endFill();
            }
        });

        return tween;
    }

    drawHitGraphics() {
        this.hitGraphics = new PIXI.Graphics();
        this.hitGraphics.beginFill(0x202020, 0);
        this.hitGraphics.drawCircle(0, 0, this.hitArea);
        this.hitGraphics.endFill();
        this.hitGraphics.zIndex = 2
        this.spinButtonContainer.addChild(this.hitGraphics);
        this.hitGraphics.addChild(this.timerMask, gameAssets.timer)
        this.hitGraphics.interactive = true;
        this.hitGraphics.on('pointerdown', async (event) => {
            
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.hitGraphics.interactive = false;
                const online = await isOnline()
                if (online || tuktukDemoState.isDemo) {
                    this.onClick();
                    this.hitGraphics.interactive = true;
                }
                else {
                    showErrorPopup("No Internet connection")
                    this.hitGraphics.interactive = true;
                }
            }
        });
        this.hitGraphics.cursor = 'pointer'
    }

    disableButton() {
        this.hitGraphics.interactive = false;
        this.hitGraphics.clear();
        this.hitGraphics.beginFill(0x202020, 0.99);
        this.hitGraphics.drawCircle(0, 0, this.hitArea);
        this.hitGraphics.endFill();
    }
    enableButton() {
        this.hitGraphics.interactive = true;
        this.hitGraphics.clear();
        this.hitGraphics.beginFill(0x202020, 0.01);
        this.hitGraphics.drawCircle(0, 0, this.hitArea);
        this.hitGraphics.endFill();
    }
    setupSpinButtonSpines() {
        // this.buttonSpineAnimation[0] = new SpineOld(PIXI.Assets.get('buttonSpinSpine').spineData)
        this.buttonSpineAnimation[0] = Spine.from({ skeleton: "buttonSpinSpine", atlas: "buttonSpinAtlas" });

        this.buttonSpineAnimation[0].state.setAnimation(0, 'spinning arrow', false);
        this.buttonSpineAnimation[0].state.timeScale = 0;
        this.buttonSpineAnimation[0].visible = false;
        this.spinButtonSprite.addChild(this.buttonSpineAnimation[0]);

        // this.buttonSpineAnimation[1] = new SpineOld(PIXI.Assets.get('buttonPlaySpine').spineData)
        this.buttonSpineAnimation[1] = Spine.from({ skeleton: "buttonPlaySpine", atlas: "buttonPlayAtlas" });

        //  this.buttonSpineAnimation[1].state.setAnimation(0, 'play_btn_loop', true);
        this.buttonSpineAnimation[1].state.timeScale = 1;
        this.spinButtonSprite.addChild(this.buttonSpineAnimation[1]);
        const playIcon = new PIXI.Sprite(PIXI.Assets.get('play_icon_normal'));
        playIcon.anchor.set(0.5)
        playIcon.scale.set(1.2)
        playIcon.position.set(20, 5)
        playIcon.zIndex = 5;
        this.buttonSpineAnimation[1].addChild(playIcon);
    }

    enablePlayButton() {
        //  this.buttonSpineAnimation[0].visible = false;
        this.buttonSpineAnimation[1].visible = true;
    }
    enableArrowButton() {
        this.buttonSpineAnimation[1].visible = false;
        //    this.buttonSpineAnimation[0].visible = true;
    }
    setupRoundText() {
        // const style = new PIXI.TextStyle({
        //     dropShadow: true,
        //     dropShadowAngle: 0,
        //     dropShadowBlur: 0,
        //     dropShadowColor: 0,
        //     dropShadowDistance: 0,
        //     stroke: 0,
        //     strokeThickness: 0,
        //     fill: '#ffffff',
        //     fontFamily: 'Arial',
        //     fontSize: 60,
        //     fontWeight: 'bolder',
        //     align: 'center'
        // });
        this.roundText = new PIXI.BitmapText("0/0", {
            fontName: 'normal-font',
            fontSize: 500,
            letterSpacing: -10,
        });

        this.roundText.anchor.set(0.5);
        this.roundText.y = -20;
        this.roundText.x = 8
        this.hitGraphics.addChild(this.roundText);

        const roundHeader = new PIXI.BitmapText("Round", {
            fontName: 'normal-font',
            fontSize: 25,
            letterSpacing: -15,
        });
        roundHeader.anchor.set(0.5)
        roundHeader.y = -230
        roundHeader.x = 8
        this.roundText.addChild(roundHeader);

        this.updateRoundText()
    }

    updateRoundText() {
        if (globalData.currentRound === 0) {
            this.roundText.text = "1"
            this.roundText.fontSize = 45
            this.roundText.children[0].text = "Round"
        } else if (globalData.currentRound + 1 === globalData.totalRounds) {
            this.roundText.text = "Round"
            this.roundText.fontSize = 35
            this.roundText.children[0].text = "Final"
        } else {
            this.roundText.text = globalData.currentRound + 1;
            this.roundText.fontSize = 45
            this.roundText.children[0].text = "Round"
        }

    }
    onClick() {        
        if (gameStates.IDLE === globalData.currentGameState) {
            if (!globalData.accessToken) return
            if (gameStates.IDLE === globalData.currentGameState) {
                this.buttonSpineAnimation[1].state.setAnimation(0, 'play_btn_loop', false);
                this.hitGraphics.alpha = 0.99
                playPlay();
                tweenFadeAppear(gameAssets.startTextContainer, false)
            } else {
                this.buttonSpineAnimation[0].state.setAnimation(0, 'spinning arrow', false);
                this.hitGraphics.interactive = false;
                playContinue();
            }
            processSpinResult()

            this.buttonSpineAnimation[0].state.timeScale = 1;
            this.spinButtonSprite.interactive = false;


            // setTimeout(() => {
            //     // this.buttonSpineAnimation[0].state.timeScale = 0
            //     this.spinButtonSprite.interactive = true;
            // }, 600);
        }
    }
}